<template>
  <div ref="iframeContainer" class="h-full">
    <iframe
      v-if="isDataLoaded"
      frameborder="0"
      :src="`https://sample.groovekart.com/manage-gkstores.php?email=${email}&token=${token}&token_type=${auth_provider}&is_paid=${is_paid}&firstname=${firstName}&lastname=${lastName}`"
      class="w-full"
      style="overflow-y: hidden"
      :style="{ height: iframeHeight }"
      @load="load"
    ></iframe>
  </div>
</template>

<script>
import auth from '@groovepages/gd-lib/auth';

export default {
  middleware: 'auth',

  data() {
    return {
      firstName: '',
      lastName: '',
      email: '',
      token: '',
      is_paid: 0,
      auth_provider: 'auth0',
      isDataLoaded: 0,
      iframeHeight: '200px',
      scrollbarSettings: {
        maxScrollbarLength: 60,
      },
    };
  },
  metaInfo() {
    return { title: 'GrooveDigital' };
  },
  async created() {
    const loggedInUser = auth.authenticatedUser();
    if (loggedInUser.auth_keycloak) {
      this.auth_provider = 'keycloak';
    }

    const fullName = loggedInUser.name;
    this.firstName = fullName;
    this.lastName = '';

    if (fullName && fullName.indexOf(' ') >= 0) {
      this.firstName = fullName.split(' ').slice(0, -1).join(' ');
      this.lastName = fullName.split(' ').slice(-1).join(' ');
    }

    this.email = loggedInUser.email;
    this.token = loggedInUser.token;
    if (this.$store.getters.isLiteUser) {
      this.is_paid = 0;
    } else {
      this.is_paid = 1;
    }

    this.isDataLoaded = 1;
  },
  async mounted() {},
  methods: {
    load() {
      this.iframeHeight = `${
        window.innerHeight -
        this.$refs.iframeContainer.getBoundingClientRect().top
      }px`;
    },
  },
};
</script>
